/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BurnNftRewardBody
 */
export interface BurnNftRewardBody {
    /**
     * 
     * @type {string}
     * @memberof BurnNftRewardBody
     */
    transactionHash?: string;
}

/**
 * Check if a given object implements the BurnNftRewardBody interface.
 */
export function instanceOfBurnNftRewardBody(value: object): value is BurnNftRewardBody {
    return true;
}

export function BurnNftRewardBodyFromJSON(json: any): BurnNftRewardBody {
    return BurnNftRewardBodyFromJSONTyped(json, false);
}

export function BurnNftRewardBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BurnNftRewardBody {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
    };
}

export function BurnNftRewardBodyToJSON(json: any): BurnNftRewardBody {
    return BurnNftRewardBodyToJSONTyped(json, false);
}

export function BurnNftRewardBodyToJSONTyped(value?: BurnNftRewardBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionHash': value['transactionHash'],
    };
}

